import type { TableRowProps as MuiTableRowProps } from '@mui/material';
import { TableRow as MuiTableRow } from '@mui/material';

/**
 * <p>
 * Based on MUI TableRow: https://mui.com/material-ui/api/table-row/
 * </p>
 * */
export const TableRow = (props: MuiTableRowProps) => <MuiTableRow {...props} />;
